import React from "react";
import styled, { css } from "styled-components";
import { Heading, SubText, SubHeading } from "./components/styles";
import { Button } from "../../components/Button.js";

//images
import link_icon from "../../images/link_icon.svg";
import desktop_icon from "../../images/desktop_icon.svg";
import mobile_icon from "../../images/mobile_icon.svg";

const Container = styled.div`
	max-width: 1280px;
	margin: 0 auto;
	padding: 72px 92px;

	@media screen and (max-width: 912px) {
		padding: 54px 20px;
	}
`;

const CardWrapper = styled.div`
	margin-top: 72px;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 2rem;
	align-items: center;
	justify-items: center;
	scroll-snap-type: x mandatory;

	@media screen and (max-width: 912px) {
		margin-top: 72px;
		overflow-x: auto;
		gap: 1rem;
		::-webkit-scrollbar {
			display: none;
		}
	}
`;

const Card = styled.div`
	width: 260px;
	height: 370px;
	padding: 48px 20px;
	border-radius: 12px;
	background: #dbe3ff;
	scroll-snap-align: start;

	${({ second }) =>
		second &&
		css`
			background: #e1fbfe;
			width: 330px;
			height: 460px;
			padding: 70px 28px;
		`}

	${({ third }) =>
		third &&
		css`
			background: #fff8bd;
		`}
`;

const SmallHeading = styled(SubHeading)`
	font-weight: 500;
`;

const CardLogo = styled.img`
	width: auto;
`;

const CardButton = styled(Button)`
	margin-top: 20px;
`;

const LinkWrap = styled.a`
	text-decoration: none;
	color: #212121;
	display: inline-block;
`;

function Integrate() {
	return (
		<Container>
			<Heading center secondary>
				Integrate in Minutes
			</Heading>
			<CardWrapper>
				<Card>
					<CardLogo src={link_icon} alt="Link Icon" loading="lazy" />
					<SmallHeading margin="24px">Verify by Link</SmallHeading>
					<SubText small margin="8px">
						Generate a tokenized link to a custom branded workflow.
						Includes enhanced features like auto-image capture, expert
						manual review, facial recognition and passive liveness
						detection.
					</SubText>
					<LinkWrap
						href="https://docs.authenticating.com/#tag/Methods/paths/~1user~1jwt/post"
						target="_blank"
						rel="noreferrer"
					>
						<CardButton secondary>See details</CardButton>
					</LinkWrap>
				</Card>
				<Card second>
					<CardLogo src={desktop_icon} alt="Desktop Icon" loading="lazy" />
					<SmallHeading subHeading margin="24px">
						Web SDK
					</SmallHeading>
					<SubText large margin="22px">
						Embed a React application within the four corners of your
						application to give users a browser-based, authentication
						experience without needing to code.
					</SubText>
					<LinkWrap
						href="https://docs.authenticating.com/#section/Verify-UItm"
						target="_blank"
						rel="noreferrer"
					>
						<CardButton large secondary>
							See details
						</CardButton>
					</LinkWrap>
				</Card>
				<Card third>
					<CardLogo src={mobile_icon} alt="Mobile Icon" loading="lazy" />
					<SmallHeading margin="24px">Mobile SDKs</SmallHeading>
					<SubText small margin="8px">
						Create mobile native applications for iOS or Android with our
						mobile SDKs that include active liveness detection for facial
						recognition and liveness detection.
					</SubText>
					<LinkWrap
						href="https://docs.authenticating.com/#section/Android-Developer-App"
						target="_blank"
						rel="noreferrer"
					>
						<CardButton secondary>See details</CardButton>
					</LinkWrap>
				</Card>
			</CardWrapper>
		</Container>
	);
}

export default Integrate;
